import { isEmpty, toString } from 'lodash';

export const escapeCsvValue = (value: string | number | undefined): string => {
  const stringValue = toString(value);
  if (isEmpty(stringValue)) return '';

  const escaped = stringValue.replace(/"/g, '""');

  return `"${escaped}"`;
};
